<template>
    <PatientRowCells :patient="patient" :phase="phase" class="table-tr">
        <span :id="`patient-${patient.id}`" class="patient-anchor"></span>

        <div class="table-td cell-length">
            <a :href="`/pacient/${patient.id}`">
                <PatientUserImage :patient="patient" unread-messages-count />

                <div class="patient-info">
                    <span class="user-name">
                        <strong>{{ patient.user | fullname }}</strong>
                        {{ patient.age }}
                    </span>
                </div>
            </a>
        </div>
    </PatientRowCells>
</template>

<script>
import PatientRowCells from './PatientRowCells'
import PatientUserImage from '@components/PatientsMatrix/Cells/PatientUserImage'

export default {
    components: {
        PatientRowCells,
        PatientUserImage
    },
    props: {
        patient: {
            type: Object,
            required: true
        },
        phase: {
            type: String,
            required: false
        }
    }
}
</script>
